import React from 'react';


const RecordMenuContext = React.createContext({
  action: {
    type: '',
    params: null
  },
  isLoading: false,
  moveToEventAction: (exerciseId, eventId) => {},
  duplicateEvent: (eventId) => {},
  duplicateExercise: (exerciseId) => {},
  deleteExercise: (exerciseId) => {},
  deleteDeployment: (deploymentId) => {},
  deleteEvent: (eventId) => {},
  deleteCompletedAnswers: (exerciseId) => {},
  deleteClass: (classId) => {},
  deleteVetVisit: (vetVisitId) => {},
  closeAction: () => {},
  setIsLoading: (isLoading) => {}
});

export default RecordMenuContext;